module.exports = __webpack_public_path__ + "static/media/color_profile.df717b6b.png";